/** Dashboard summary merge across risk payloads.
 *
 * Contract (docs/risks.md § Dashboard summary):
 * - Контроллеров = organization_controller_total — always the full company pool
 * - Выбрано = distinct controllers matching non-risk filters (firmware, …)
 * - В рисках = distinct controllers with ≥1 selected risk after soft filters
 */
export function mergeControllerSummary(payloads = []) {
  const organizationControllerTotal =
    payloads
      .map((payload) => payload.organization_controller_total ?? payload.total_controllers)
      .find((value) => value != null) ?? null;

  const atRiskIds = new Set();
  let sawAtRiskIds = false;
  let atRiskFallback = 0;
  const selectedIds = new Set();
  let sawSelectedIds = false;
  let selectedFallback = 0;

  for (const payload of payloads) {
    if (Array.isArray(payload.at_risk_controller_ids)) {
      sawAtRiskIds = true;
      for (const id of payload.at_risk_controller_ids) {
        const numericId = Number(id);
        if (Number.isFinite(numericId) && numericId > 0) {
          atRiskIds.add(numericId);
        }
      }
    } else {
      atRiskFallback += Number(payload.controllers_at_risk ?? payload.total_at_risk ?? 0) || 0;
    }

    if (Array.isArray(payload.selected_controller_ids)) {
      sawSelectedIds = true;
      for (const id of payload.selected_controller_ids) {
        const numericId = Number(id);
        if (Number.isFinite(numericId) && numericId > 0) {
          selectedIds.add(numericId);
        }
      }
    } else if (payload.controllers_selected != null) {
      selectedFallback = Math.max(selectedFallback, Number(payload.controllers_selected) || 0);
    }
  }

  return {
    organization_controller_total: organizationControllerTotal,
    controllers_selected: sawSelectedIds ? selectedIds.size : selectedFallback || null,
    controllers_at_risk: sawAtRiskIds ? atRiskIds.size : atRiskFallback,
  };
}
